export default __webpack_public_path__ + "static/32-b05e8e5e954e5d08ecf7acddf46af0cc.gif";